import React,{useState} from 'react';
import {HashRouter, Route, Routes} from 'react-router-dom'
import Paropdashboard from './Screen/Paropdashboard';
import Tcdashboard from './Screen/Tcdashboard';
import Kdpcorpdashboard from './Screen/Kdpcorpdashboard';
import Kdptecdashboard from './Screen/Kdptecdashboard';
import Oatdashboard from './Screen/Oatdashboard';
import Login from './Screen/Login';
import Foundationdashboard from './Screen/Foundationdashboard';
import SuperAdmdashboard from './Screen/SuperAdmdashboard';
import Forgotpassword from './Screen/Forgotpassword';
import Resetpassword from './Screen/Resetpassword';

import Corpadduser from './Screen/Corpadduser';
import CorpProfile from './Screen/CorpProfile';
import Corpassign from './Screen/Corpassign';
import Corpsection from './Screen/Corpsection';
import CorpAddRole from './Screen/CorpAddRole';
import CorpLHImages from './Screen/CorpLHImages';
import CorpLHContent from './Screen/CorpLHContent';
import CorpGBContent from './Screen/CorpGBContent';
import CorpGBImages from './Screen/CorpGBImages';
import CorpOurteamContent from './Screen/CorpOurteamContent';
import CorpEditPop from './Screen/CorpEditPop';
import CorpLifehere from './Screen/CorpLifehere';
import CorpGivingback from './Screen/CorpGivingback';
import CorpCareer from './Screen/CorpCareer';
import CorpContentCareers from './Screen/CorpContentCareers';
import CorpOurteam from './Screen/CorpOurteam';


import Oatadduser from './Screen/Oatadduser';
import OatProfile from './Screen/OatProfile';
import Oatassign from './Screen/Oatassign';
import Oatsection from './Screen/Oatsection';
import OatEditpop from './Screen/OatEditpop';
import OatAddRole from './Screen/OatAddRole';
import OatHome from './Screen/OatHome';
import OatEntity from './Screen/OatEntity';
import OatCategory from './Screen/OatCategory';
import OatAnnouncement from './Screen/OatAnnouncement';
import OatSkill from './Screen/OatSkill';
import OatEducation from './Screen/OatEducation';
import OatDepartment from './Screen/OatDepartment';
import OatDesignation from './Screen/OatDesignation';
import OatEditActivepop from './Screen/OatEditActivepop';

import OatEditInactivepop from './Screen/OatEditInactivepop';

import Tcadduser from './Screen/Tcadduser';
import TcAddUserRole from './Screen/TcAddUserRole';
import TcProfile from './Screen/TcProfile';
import Tcassign from './Screen/Tcassign';
import Tcsection from './Screen/Tcsection';
import TcWinner from './Screen/TcWinner';
import TcAboutus from './Screen/TcAboutus';
import TcTerms from './Screen/TcTerms';
import TcPrivacy from './Screen/TcPrivacy';
import TcUnfollow from './Screen/TcUnfollow';
import TcReport from './Screen/TcReport';
import TcTransaction from './Screen/TcTransaction';
import TcAddress from './Screen/TcAddress';
import TcContent from './Screen/TcContent';
import TcEditPop from './Screen/TcEditPop'



import TecProfile from './Screen/TecProfile';
import Tecassign from './Screen/Tecassign';
import TecEditpop from './Screen/TecEditpop';
import Tecsection from './Screen/Tecsection';
import TecLeaders from './Screen/TecLeaders';
import TecExpertise from './Screen/TecExpertise';
import TecProduct from './Screen/TecProduct';
import TecFirst from './Screen/TecFirst';
import TecFooter from './Screen/TecFooter';
import TecTechnology from './Screen/TecTechnology';
import TecAddRole from './Screen/TecAddRole'
import TecAddress from './Screen/TecAddress'
import TecAbout from './Screen/TecAbout'
import TecLife from './Screen/TecLife'
import TecGiving from './Screen/TecGiving'
import TecCareers from './Screen/TecCareers'
import Tecadduser from './Screen/Tecadduser';

import TecMobile from './Screen/TecMobile'
import TecWeb from './Screen/TecWeb'
import TecCloud from './Screen/TecCloud'
import TecData from './Screen/TecData'
import TecBusiness from './Screen/TecBusiness'
import TecDigital from './Screen/TecDigital'
import TecServices from './Screen/TecServices'
import TecITES from './Screen/TecITES'
import TecStaff from './Screen/TecStaff'
import TecQuality from './Screen/TecQuality'
import TecIndex from './Screen/TecIndex'
import TecCompany from './Screen/TecCompany'
import TecSExpertise from './Screen/TecSExpertise'
import TecSTechnology from './Screen/TecSTechnology'
import TecSProduct from './Screen/TecSProduct'
import TecTalk from './Screen/TecTalk'



import ParoAdduser from './Screen/ParoAdduser';
import Paroprofile from './Screen/Paroprofile';
import ParoSection from './Screen/ParoSection';
import ParoAssign from './Screen/ParoAssign';
import ParoAddRole from './Screen/ParoAddRole';
import ParoEditPop from './Screen/ParoEditPop';
import ParoSectionIndexTop from './Screen/ParoSectionIndexTop';
import ParoIndexSlider from './Screen/ParoIndexSlider';
import ParoIndexbottom from './Screen/ParoIndexbottom';
import ParoCauses from './Screen/ParoCauses';
import ParoIndex from '../src/Screen/Paroindex';
import ParoPayment from '../src/Screen/ParoPayment';

import Superventures from './Screen/Superventures';
import Superusers from './Screen/Superusers';
import Superprofile from './Screen/Superprofile';
import UserView from './Screen/UserView';

import FoundAdduser from './Screen/FoundAdduser';
import FoundEditPop from './Screen/FoundEditPop';
import FoundAddRole from './Screen/FoundAddRole';
import Foundprofile from './Screen/Foundprofile';

import FoundSection from './Screen/FoundSection';
import FoundSectionHome from './Screen/FoundSectionHome';
import FoundSectionFS from './Screen/FoundSectionFS';
import FoundSectionDWH from './Screen/FoundSectionDWH';
import FoundSectionWWH from './Screen/FoundSectionWWH';
import FoundSectionBPF from './Screen/FoundSectionBPF';
import FoundSectionContributors from './Screen/FoundSectionContributors';
import FoundSectionContact from './Screen/FoundSectionContact';

import FoundSectionWhoweare from './Screen/FoundSectionWhoweare';
import FoundSectionOM from './Screen/FoundSectionOM';
import FoundSectionOF from './Screen/FoundSectionOF';

import FoundSectionDifferentiators from './Screen/FoundSectionDifferentiators';
import FoundSectionOD from './Screen/FoundSectionOD';

import FoundSectionJS from './Screen/FoundSectionJS';
import FoundSectionET from './Screen/FoundSectionET';
import FoundSectionEI from './Screen/FoundSectionEI';

import FoundSectionMainContributors from './Screen/FoundSectionMainContributors';

import FoundAssign from './Screen/FoundAssign';
import AccountActivation from './Screen/AccountActivation';
import AcivatePage from './Screen/AcivatePage';

import Department from '../src/Screen/Department'
import OatTrainerpageMain from './Components/OatTrainerpageMain';
import Dropdownget from '../src/Components/Dropdownget '

import OtpVerifyPage from '../src/Screen/otpPage'



function App() {

  return (
    <HashRouter>
      <Routes>
      <Route exact path="/" element={<Login />} />
        <Route path="/Paropakari" element={<Paropdashboard />} />
        <Route path="/Thats Cool" element={<Tcdashboard />} />
        <Route path="/OAT" element={<Oatdashboard />} />
        <Route path="/Kdp Corp" element={<Kdpcorpdashboard />} />
        <Route path="/Kdp Tec" element={<Kdptecdashboard />} />
        <Route path="/Kdp Foundation" element={<Foundationdashboard />} />
        <Route path="/SuperAdmdashboard" element={<SuperAdmdashboard />} />

        <Route path="/Forgotpassword" element={<Forgotpassword />} />
        <Route path="/Resetpassword" element={<Resetpassword />} />
       <Route path="/OtpVerifyPage"  element={<OtpVerifyPage/>}/>
        <Route path="/Corpadduser" element={<Corpadduser />} />
        <Route path="/CorpProfile" element={<CorpProfile />} />
        <Route path="/Corpassign" element={<Corpassign />} />
        <Route path="/Corpsection" element={<Corpsection />} />
        <Route path="/CorpAddRole"element={<CorpAddRole/>}/>
        <Route path="/CorpLHImages" element={<CorpLHImages/>}/>
        <Route path="/CorpLHContent" element={<CorpLHContent/>}/>
        <Route path="/CorpGBContent" element={<CorpGBContent/>}/>
        <Route path="/CorpGBImages" element={<CorpGBImages/>}/>
        <Route path="/CorpContentCareers" element={<CorpContentCareers/>}/>
        <Route path="/CorpOurteamContent" element={<CorpOurteamContent/>}/>
        <Route path="/CorpOurteam" element={<CorpOurteam/>}/>
        <Route path="/CorpEditPop" element={<CorpEditPop/>}/>
        <Route path="/CorpLifehere" element={<CorpLifehere/>}/>
        <Route path="/CorpGivingback" element={<CorpGivingback/>}/>
        <Route path="/CorpCareer" element={<CorpCareer/>}/>
        <Route path="/kdpcorpdashboard" element={<Kdpcorpdashboard/>}></Route>


        <Route path="/Oatadduser" element={<Oatadduser />} />
        <Route path="/OatProfile" element={<OatProfile />} />
        <Route path="/Oatassign" element={<Oatassign />} />
        <Route path="/Oatsection" element={<Oatsection />} />
        <Route path="/OatEditpop" element={<OatEditpop/>}></Route>
        <Route path="/OatAddRole" element={<OatAddRole/>}></Route>
       
        <Route path="/OatHome" element={<OatHome/>} />
        <Route path="/OatEntity" element={<OatEntity />} />
        <Route path="/OatCategory" element={<OatCategory/>}></Route>
        <Route path="/OatAnnouncement" element={<OatAnnouncement/>}></Route>
        <Route path="/OatSkill" element={<OatSkill/>} />
        <Route path="/OatEducation" element={<OatEducation />} />
        <Route path="/OatDepartment" element={<OatDepartment/>}></Route>
        <Route path="/OatDesignation" element={<OatDesignation/>}></Route>
        <Route path="/OatEditActivepop" element={<OatEditActivepop/>}></Route>
        <Route path="/OatEditInactivepop" element={<OatEditInactivepop/>}></Route>


        <Route path="/Tcadduser" element={<Tcadduser />} />
        <Route path="/TcAddUserRole" element={<TcAddUserRole/>}/>
         <Route path="/TcProfile" element={<TcProfile />} />
          <Route path="/Tcassign" element={<Tcassign />} />
          <Route path="/Tcsection" element={<Tcsection />} />
           <Route path="/TcWinner" element={<TcWinner />} />
            <Route path="/TcAboutus" element={<TcAboutus />} />
             <Route path="/TcTerms" element={<TcTerms />} />
              <Route path="/TcPrivacy" element={<TcPrivacy />} />
              <Route path="/TcUnfollow" element={<TcUnfollow />} />
               <Route path="/TcTransaction" element={<TcTransaction />} /> 
               <Route path="/TcReport" element={<TcReport />} />
               <Route path="/TcEditPop" element={<TcEditPop />} /> 
               <Route path="/TcAddress" element={<TcAddress />} />
               <Route path="/TcContent" element={<TcContent />} />


               <Route path="/Tecadduser" element={<Tecadduser />} />
        <Route path="/TecProfile" element={<TecProfile />} />
        <Route path="/Tecassign" element={<Tecassign />} />
        <Route path="/TecEditpop" element={<TecEditpop />} />
        <Route path="/Tecsection" element={<Tecsection />} />
        <Route path="/TecFirst" element={<TecFirst />} />
        <Route path="/TecLeaders" element={<TecLeaders />} />
        <Route path="/TecProduct" element={<TecProduct />} />
        <Route path="/TecExpertise" element={<TecExpertise />} />
        <Route path="/TecTechnology" element={<TecTechnology />} />
        <Route path="/TecFooter" element={<TecFooter />} />
        <Route path="/TecAddRole" element={<TecAddRole />} />
        <Route path="/TecAddress" element={<TecAddress />} />
        <Route path="/TecAbout" element={<TecAbout />} />
        <Route path="/TecLife" element={<TecLife />} />
        <Route path="/TecGiving" element={<TecGiving />} />
        <Route path="/TecCareers" element={<TecCareers />} />
         <Route path="/TecMobile" element= {<TecMobile />} />
         <Route path="/TecWeb" element= {<TecWeb />} />
         <Route path="/TecCloud" element= {<TecCloud />} />
         <Route path="/TecData" element= {<TecData />} />
         <Route path="/TecBusiness" element= {<TecBusiness />} />
         <Route path="/TecDigital" element= {<TecDigital />} />
         <Route path="/TecServices" element= {<TecServices />} />
         <Route path="/TecITES" element= {<TecITES />} />
         <Route path="/TecStaff" element= {<TecStaff />} />
         <Route path="/TecQuality" element= {<TecQuality />} />
         <Route path="/TecIndex" element= {<TecIndex />} />
         <Route path="/TecCompany" element= {<TecCompany />} />
         <Route path="/TecSExpertise" element= {<TecSExpertise />} />
         <Route path="/TecSTechnology" element= {<TecSTechnology />} />
         <Route path="/TecSProduct" element= {<TecSProduct />} />
         <Route path="/TecTalk" element= {<TecTalk />} />

        <Route path="/ParoAdduser" element={<ParoAdduser/>}></Route>
       <Route path="/Paroprofile" element={<Paroprofile/>}></Route>
       <Route path="/ParoSection" element={<ParoSection/>}></Route>
       <Route path="/ParoAssign" element={<ParoAssign/>}></Route>
       <Route path="/ParoAddRole" element={<ParoAddRole/>}></Route>
       <Route path="/ParoEditPop" element={<ParoEditPop/>}></Route>
       <Route path="/ParoSectionIndexTop" element={<ParoSectionIndexTop/>}></Route>
       <Route path="/ParoIndexSlider" element={<ParoIndexSlider/>}></Route>
       <Route path="/ParoIndexbottom" element={<ParoIndexbottom/>}></Route>
       <Route path="/ParoCauses" element={<ParoCauses/>}></Route>
       <Route path="/ParoIndex" element={<ParoIndex/>}></Route>
       <Route path="/ParoPayment" element={<ParoPayment/>}></Route>




       <Route path="/Superventures" element={<Superventures/>}></Route>
       <Route path="/Superusers" element={<Superusers/>}></Route>
       <Route path="/Superprofile" element={<Superprofile/>}></Route>
       <Route path="/UserView" element={<UserView/>}></Route>

       <Route path="/FoundAdduser" element={<FoundAdduser/>}></Route>
       <Route path="/FoundEditPop" element={<FoundEditPop/>}></Route>
       <Route path="/FoundAddRole" element={<FoundAddRole/>}></Route>
       <Route path="/Foundprofile" element={<Foundprofile/>}></Route>
       <Route path="/FoundSection" element={<FoundSection/>}></Route>
       <Route path="/FoundSectionHome" element={<FoundSectionHome/>}></Route>
       <Route path="/FoundSectionFS" element={<FoundSectionFS/>}></Route>
       <Route path="/FoundSectionDWH" element={<FoundSectionDWH/>}></Route>
       <Route path="/FoundSectionWWH" element={<FoundSectionWWH/>}></Route>
       <Route path="/FoundSectionBPF" element={<FoundSectionBPF/>}></Route>
       <Route path="/FoundSectionContributors" element={<FoundSectionContributors/>}></Route>
       <Route path="/FoundSectionContact" element={<FoundSectionContact/>}></Route>

       <Route path="/FoundSectionWhoweare" element={<FoundSectionWhoweare/>}></Route>
       <Route path="/FoundSectionOM" element={<FoundSectionOM/>}></Route>
       <Route path="/FoundSectionOF" element={<FoundSectionOF/>}></Route>

       <Route path="/FoundSectionJS" element={<FoundSectionJS/>}></Route>
       <Route path="/FoundSectionET" element={<FoundSectionET/>}></Route>
       <Route path="/FoundSectionEI" element={<FoundSectionEI/>}></Route>
      
       <Route path="/FoundSectionDifferentiators" element={<FoundSectionDifferentiators/>}></Route>
       <Route path="/FoundSectionOD" element={<FoundSectionOD/>}></Route>

       <Route path="/FoundSectionMainContributors" element={<FoundSectionMainContributors/>}></Route>

      <Route path="/FoundAssign" element={<FoundAssign/>}></Route>


      <Route path="AccountActivation" element={<AccountActivation/>}></Route>
      <Route path="AcivatePage/:Id" element={<AcivatePage/>}></Route>

      <Route path="/Department" element={<Department/>}></Route>

      <Route path="/OatTrainerpageMain" element={<OatTrainerpageMain/>}></Route>

<Route path="/Dropdownget" element={<Dropdownget/>}></Route>

      </Routes>
    </HashRouter>
  );
}

export default App;
